import commentService from "../api/commentService";
import { useQuery } from "@tanstack/react-query";

export const useComments = (taskId) => {
  const { getComments } = commentService();

  return useQuery({
    queryKey: ["get-comments", taskId],
    queryFn: async () => {
      const res = await getComments(taskId);
      return res.data;
    },
    enabled: !!taskId,
  });
};

export const useCommentsCount = (taskId) => {
  const { getCommentsCount } = commentService();

  return useQuery({
    queryKey: ["get-comments-count", taskId],
    queryFn: async () => {
      const res = await getCommentsCount(taskId);
      return res.data;
    },
    enabled: !!taskId,
  });
};
